import { useCallback, useEffect, useRef } from 'react'

type Props = {
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void
}

type Result = {
    handleSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}

export function useOnboardingPageTemplateLogic({ onSubmit }: Props): Result {
    const submitTimeout = useRef<number | null>(null)

    useEffect(() => {
        return () => {
            if (submitTimeout.current) window.clearTimeout(submitTimeout.current)
        }
    }, [])

    const handleSubmit = useCallback(
        (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault()
            event?.persist?.()
            if (submitTimeout.current) window.clearTimeout(submitTimeout.current)
            submitTimeout.current = window.setTimeout(() => {
                onSubmit?.(event)
                submitTimeout.current = null
            }, 300)
        },
        [onSubmit],
    )

    return {
        handleSubmit,
    }
}
